import React from 'react'

import { Icon } from '@clientbase/clientbase-library'
import { Tooltip, TooltipProps } from '@mui/material'

import { theme } from 'styles/theme'

type InfoHintProps = {
  /** Texto (ou conteúdo) da explicação. */
  title: TooltipProps['title']
  placement?: TooltipProps['placement']
  /**
   * Ícone de 14px sem o deslocamento vertical, para ficar centrado em rótulo
   * pequeno (11-12px, caixa alta), como o "VALOR" do detalhe. O padrão (17px com
   * mt 2px) é o das Métricas, alinhado a títulos de 14px.
   */
  compact?: boolean
}

/**
 * (i) com explicação no hover. É o padrão das Métricas de faturamento (MetricCard):
 * ícone de 17px em neutral[700], tooltip com seta abrindo à direita e sem atraso no
 * toque. Centralizado aqui para os cards, cabeçalhos e rótulos usarem o mesmo ícone.
 *
 * O clique não propaga: vários usos ficam dentro de cards clicáveis (aplicam filtro) ou de
 * cabeçalhos ordenáveis, e abrir a explicação não pode disparar a ação do pai. O
 * `data-info-hint` deixa o pai reconhecer o ícone (ver SortTooltip em SortableTableHead).
 */
const InfoHint = ({
  title,
  placement = 'right',
  compact = false
}: InfoHintProps) => (
  <Tooltip enterTouchDelay={0} arrow placement={placement} title={title}>
    <div
      data-info-hint
      onClick={(e) => e.stopPropagation()}
      style={{ display: 'inline-flex', flexShrink: 0 }}
    >
      <Icon
        icon="info"
        colorSX={theme.palette.neutral[700]}
        sx={{
          mt: compact ? 0 : '2px',
          color: theme.palette.neutral[700],
          width: compact ? '14px' : '17px',
          height: compact ? '14px' : '17px'
        }}
      />
    </div>
  </Tooltip>
)

export default InfoHint
